"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSafeMultisendTransaction = void 0;
const utils_1 = require("ethers/lib/utils");
const constants_1 = require("../constants");
const abis_1 = require("../abis");
const types_1 = require("../types");
const utils_2 = require("./utils");
const multisendInterface = new utils_1.Interface(abis_1.multisendAbi);
exports.createSafeMultisendTransaction = (txns) => {
    const data = multisendInterface.encodeFunctionData("multiSend", [
        utils_2.joinHexData(txns.map(tx => utils_2.abiEncodePacked({ type: "uint8", value: tx.operation }, { type: "address", value: tx.to }, { type: "uint256", value: tx.value }, { type: "uint256", value: utils_2.getHexDataLength(tx.data) }, { type: "bytes", value: tx.data }))),
    ]);
    return {
        to: constants_1.SAFE_MULTISEND_ADDRESS,
        value: "0",
        data: data,
        operation: types_1.OperationType.DelegateCall,
    };
};
